import React from "react";
import {css, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {BrandCheckboxCheckedIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {InquiryButtonTypeName} from "../../../../../constants/inquiry_button_type";
import {ApplicationModalButton} from "../../../../application/components/ApplicationModalButton";
import {GTMEventApplicationSourceSection} from "../../../../application/types/lead/GTMEvenApplicationSourceSection";
import {getStorageSentPropertyApplications} from "../../../../application/utils/application_property_storage";
import {ApplicationSource, ApplicationSourceSection} from "../../../../application/utils/form/application_form_source";
import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";
import {isPropertyArchived} from "../../../../property/utils/is_property_archived";
import {IGTMEventLeadForm} from "../../../../tracking/google_tag_manager/gtm_event_form_open";
import {useComparisonToolContext} from "../../../contexts/comparison_tool_context";
import {ShowPhoneButton} from "../common/ShowPhoneButton";

export const ContactCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const theme = useTheme();
    const {isPrinting} = useComparisonToolContext();
    const propertyDetails = props.item;

    const sentPropertyApplications = getStorageSentPropertyApplications();
    const isInSent = Boolean(sentPropertyApplications.find((propertyId) => propertyId === propertyDetails.id));
    const isArchived = isPropertyArchived(propertyDetails);
    const gtmData: IGTMEventLeadForm = {
        clickText: InquiryButtonTypeName.ASK,
        source: GTMEventApplicationSourceSection.COMPARISON_TOOL,
        vendorName: propertyDetails.offer.vendor.name ?? propertyDetails.offer.vendor.id.toString(),
        offerName: propertyDetails.offer.name ?? propertyDetails.offer.id.toString()
    };

    return (
        <div>
            {isInSent && (
                <div css={contactCell}>
                    <div css={sentInformationStyle}>
                        <BrandCheckboxCheckedIcon size="2.4" wrapperSize="2.4" wrapperColor={theme.colors.primary} />
                        <Text variant="info_txt_1" css={sentInformationTextStyle}>
                            Wysłano
                        </Text>
                    </div>
                    <ShowPhoneButton phoneNumber={propertyDetails.offer.configuration.phone_clip} isPrinting={isPrinting} />
                </div>
            )}
            {!isInSent && isArchived && (
                <div css={contactCell}>
                    <Text variant="info_txt_1" strong>
                        Oferta archiwalna
                    </Text>
                </div>
            )}
            {!isInSent && !isArchived && (
                <ApplicationModalButton
                    source={ApplicationSource.ComparisonToolProperty}
                    sourceSection={ApplicationSourceSection.TABLE}
                    vendorId={propertyDetails.offer.vendor.id}
                    offerId={propertyDetails.offer.id}
                    propertyId={propertyDetails.id}
                    render={({openModal}) => (
                        <Button onClick={() => openModal(gtmData)} type="button" variant="highlight_primary">
                            Zapytaj
                        </Button>
                    )}
                />
            )}
        </div>
    );
};

//  Styles
const contactCell = css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 0.8rem;
`;

const sentInformationStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const sentInformationTextStyle = css`
    font-weight: 700;
`;
import React from "react";
import {css, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {BrandCheckboxCheckedIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {InquiryButtonTypeName} from "../../../../../constants/inquiry_button_type";
import {ApplicationModalButton} from "../../../../application/components/ApplicationModalButton";
import {GTMEventApplicationSourceSection} from "../../../../application/types/lead/GTMEvenApplicationSourceSection";
import {getStorageSentPropertyApplications} from "../../../../application/utils/application_property_storage";
import {ApplicationSource, ApplicationSourceSection} from "../../../../application/utils/form/application_form_source";
import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";
import {isPropertyArchived} from "../../../../property/utils/is_property_archived";
import {IGTMEventLeadForm} from "../../../../tracking/google_tag_manager/gtm_event_form_open";
import {useComparisonToolContext} from "../../../contexts/comparison_tool_context";
import {ShowPhoneButton} from "../common/ShowPhoneButton";

export const ContactCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const theme = useTheme();
    const {isPrinting} = useComparisonToolContext();
    const propertyDetails = props.item;

    const sentPropertyApplications = getStorageSentPropertyApplications();
    const isInSent = Boolean(sentPropertyApplications.find((propertyId) => propertyId === propertyDetails.id));
    const isArchived = isPropertyArchived(propertyDetails);
    const gtmData: IGTMEventLeadForm = {
        clickText: InquiryButtonTypeName.ASK,
        source: GTMEventApplicationSourceSection.COMPARISON_TOOL,
        vendorName: propertyDetails.offer.vendor.name ?? propertyDetails.offer.vendor.id.toString(),
        offerName: propertyDetails.offer.name ?? propertyDetails.offer.id.toString()
    };

    return (
        <div>
            {isInSent && (
                <div css={contactCell}>
                    <div css={sentInformationStyle}>
                        <BrandCheckboxCheckedIcon size="2.4" wrapperSize="2.4" wrapperColor={theme.colors.primary} />
                        <Text variant="info_txt_1" css={sentInformationTextStyle}>
                            Wysłano
                        </Text>
                    </div>
                    <ShowPhoneButton phoneNumber={propertyDetails.offer.configuration.phone_clip} isPrinting={isPrinting} />
                </div>
            )}
            {!isInSent && isArchived && (
                <div css={contactCell}>
                    <Text variant="info_txt_1" strong>
                        Oferta archiwalna
                    </Text>
                </div>
            )}
            {!isInSent && !isArchived && (
                <ApplicationModalButton
                    source={ApplicationSource.ComparisonToolProperty}
                    sourceSection={ApplicationSourceSection.TABLE}
                    vendorId={propertyDetails.offer.vendor.id}
                    offerId={propertyDetails.offer.id}
                    propertyId={propertyDetails.id}
                    render={({openModal}) => (
                        <Button onClick={() => openModal(gtmData)} type="button" variant="highlight_primary">
                            Zapytaj
                        </Button>
                    )}
                />
            )}
        </div>
    );
};

//  Styles
const contactCell = css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 0.8rem;
`;

const sentInformationStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const sentInformationTextStyle = css`
    font-weight: 700;
`;
